var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.326,
    height: 36.326,
    viewBox: "0 0 36.326 36.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-magnifying-glass",
    "data-name": "Icon open-magnifying-glass",
    d: "M15.75,0a15.75,15.75,0,0,0,0,31.5,15.567,15.567,0,0,0,7.47-1.845,4.5,4.5,0,0,0,.585.585l4.5,4.5a4.59,4.59,0,1,0,6.48-6.48l-4.5-4.5a4.5,4.5,0,0,0-.72-.585,15.538,15.538,0,0,0,1.98-7.47A15.767,15.767,0,0,0,15.8-.045Zm0,4.5A11.2,11.2,0,0,1,27,15.75a11.284,11.284,0,0,1-2.97,7.74l-.135.135a4.5,4.5,0,0,0-.585.585,11.26,11.26,0,0,1-7.6,2.835,11.25,11.25,0,0,1,0-22.5Z",
    transform: "translate(0 0.045)",
    fill: "#527991"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifyingGlass.da36689f.svg";
export { ForwardRef as ReactComponent };